import { LazyLoad } from 'app/utils';

export const CourseFormPage = LazyLoad(
  () => import('./index'),
  (module) => module.CourseFormPage,
);
